
(function () {
  'use strict';
  if (!document.body.classList.contains('tm57-shell')) return;
  if (window.TMSiteShellV57) { window.TMSiteShellV57.scan(document); return; }
  var controllers = new Map();
  function mount(root) {
    if (controllers.has(root)) return;
    var menu = root.querySelector('[data-tmnav-mobile]');
    var toggle = menu && menu.querySelector('summary');
    if (!menu || !toggle) return;
    var events = new AbortController();
    function on(target, name, callback, options) { target.addEventListener(name, callback, Object.assign({signal: events.signal}, options || {})); }
    function close(restoreFocus) { if (!menu.open) return; menu.open = false; if (restoreFocus) toggle.focus(); }
    on(root, 'keydown', function (event) {
      if (event.key === 'Escape' && menu.open) { close(true); event.preventDefault(); event.stopPropagation(); }
    });
    on(document, 'click', function (event) { if (!root.contains(event.target)) close(false); });
    on(root, 'focusout', function (event) { if (event.relatedTarget && !root.contains(event.relatedTarget)) close(false); });
    on(root, 'click', function (event) {
      var link = event.target.closest('a');
      if (link && (menu.contains(link) || link.closest('[data-source="cart-drawer"]'))) close(false);
    });
    on(menu, 'submit', function () { close(false); });
    on(window, 'pagehide', function () { close(false); });
    function measure() {
      var height = Math.round(root.getBoundingClientRect().height);
      document.body.style.setProperty('--header_height', height + 'px');
      document.body.style.setProperty('--dynamic_header_height', height + 'px');
    }
    var observer;
    if ('ResizeObserver' in window) { observer = new ResizeObserver(measure); observer.observe(root); }
    else on(window, 'resize', measure, {passive:true});
    measure();
    controllers.set(root, function () { events.abort(); if (observer) observer.disconnect(); close(false); });
  }
  function scan(scope) { scope.querySelectorAll('[data-tmnav-shell-v57]').forEach(mount); }
  window.TMSiteShellV57 = { scan: scan };
  function start() { scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (destroy, root) { if (event.target.contains(root)) { destroy(); controllers.delete(root); } });
  });
}());
